module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/visa-logo-790587e151b12356d06eb77c56ac658a.svg";